import { Box } from "@mui/material";
import "./toggle.scss";
import { styled } from '@mui/material';

const ToggleWrapper = styled(Box)(({ theme: { palette } }) => ({
  "& input:checked + .slider": {
    backgroundColor: palette.theme.primary[700],
  },
  "& .slider": {
    backgroundColor: palette.theme.secondary[200],
    ":hover": {
      backgroundColor: palette.theme.secondary[300],
    },
  },
  "& input": {
    display: "none",
  },
}));

interface IToggle {
  checked: boolean;
  onChange: () => void;
}

const Toggle = (props: IToggle) => {
  return (
    <ToggleWrapper>
      <label className="switch">
        <input type="checkbox" {...props} />
        <span className="slider round"></span>
      </label>
    </ToggleWrapper>
  );
};

export { Toggle };
export default Toggle;
